import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { getOperation } from 'modules/transactions/redux/operationActions';
import { CustomOperation } from '../types/CustomOperation';

type UseGetOperationProps = {
  operationId: string | undefined;
};

export const useGetOperation = ({ operationId }: UseGetOperationProps) => {
  const [operation, setOperation] = useState<CustomOperation>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchOperation = useCallback(async () => {
    if (!operationId) return;

    setIsLoading(true);

    try {
      const operation = await store.dispatch(
        getOperation(operationId, {
          fieldsToPopulate: [
            'transactions.partner',
            'transactions.shareClass',
            'transactions.newShareClass',
          ],
        })
      );

      setOperation(operation);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }, [operationId]);

  useEffect(() => {
    fetchOperation();
  }, [fetchOperation]);

  return { data: { operation }, isLoading };
};
